import React from "react";

import "./EditHeader.css";
import { Icon } from "../../Icon/Icon";
import { StatusDisplay } from "../StatusDisplay/StatusDisplay";
import { useTranslation } from "react-i18next";

export const EditHeader = ({ type, name, status, goBack }) => {
  const { t } = useTranslation();
  return (
    <div className="EditHeader">
      <div className="EditHeader__action" onClick={goBack}>
        <div className="EditHeader__icon">
          <Icon name="iconDropdown" width={21} height={11} />
        </div>
      </div>
      <div className="EditHeader__content">
        <div className="EditHeader__content--type">{t(type)}</div>
        <div className="EditHeader__content--name">{t(name)}</div>
        <div className="EditHeader__content--status">
          <StatusDisplay status={status} />
        </div>
      </div>
    </div>
  );
};
